import _slicedToArray from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["loading", "children"];
import _regeneratorRuntime from "/home/runner/work/nzk-hosted-pages/nzk-hosted-pages/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as React from 'react';
import { createSlice, configureStore, bindActionCreators } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, persistStore } from 'redux-persist';
import '@stripe/stripe-js';
import { createSelectorHook, createDispatchHook, Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
var isClient = typeof window === 'object';

var formatCurrencyString = function formatCurrencyString(_ref) {
  var value = _ref.value,
      currency = _ref.currency,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? isClient ? navigator.language : 'en-US' : _ref$language;
  var numberFormat = new Intl.NumberFormat(language, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol'
  });
  var parts = numberFormat.formatToParts(value);
  var zeroDecimalCurrency = true;

  var _iterator = _createForOfIteratorHelper(parts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;

      if (part.type === 'decimal') {
        zeroDecimalCurrency = false;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  value = zeroDecimalCurrency ? value : value / 100;
  return numberFormat.format(value.toFixed(2));
};

function updateFormattedTotalPrice(state) {
  state.formattedTotalPrice = formatCurrencyString({
    value: state.totalPrice,
    currency: state.currency,
    language: state.language
  });
}

function updateFormattedValue(state, id) {
  state.cartDetails[id].formattedValue = formatCurrencyString({
    value: state.cartDetails[id].value,
    currency: state.currency,
    language: state.language
  });
}

function updateFormattedPrice(state, id) {
  state.cartDetails[id].formattedPrice = formatCurrencyString({
    value: state.cartDetails[id].price,
    currency: state.currency,
    language: state.language
  });
}

function Entry(_ref2) {
  var state = _ref2.state,
      id = _ref2.id,
      product = _ref2.product,
      quantity = _ref2.quantity,
      price_metadata = _ref2.price_metadata,
      product_metadata = _ref2.product_metadata;
  return _objectSpread(_objectSpread({}, product), {}, {
    id: id,
    quantity: quantity,
    value: product.price * quantity,
    price_data: _objectSpread(_objectSpread({}, product.price_data), price_metadata),
    product_data: _objectSpread(_objectSpread({}, product.product_data), product_metadata)
  });
}

function createEntry(_ref3) {
  var state = _ref3.state,
      id = _ref3.id,
      product = _ref3.product,
      count = _ref3.count,
      price_metadata = _ref3.price_metadata,
      product_metadata = _ref3.product_metadata;
  var entry = Entry({
    state: state,
    id: id,
    product: product,
    quantity: count,
    price_metadata: price_metadata,
    product_metadata: product_metadata
  });
  state.cartDetails[id] = entry;
  updateFormattedValue(state, id);
  updateFormattedPrice(state, id);
  state.totalPrice += entry.value;
  state.cartCount += count;
  updateFormattedTotalPrice(state);
}

function updateEntry(_ref4) {
  var state = _ref4.state,
      id = _ref4.id,
      count = _ref4.count,
      price_metadata = _ref4.price_metadata,
      product_metadata = _ref4.product_metadata;
  var entry = state.cartDetails[id];
  if (entry.quantity + count <= 0) return removeEntry({
    state: state,
    id: id
  });
  state.cartDetails[id] = Entry({
    id: id,
    state: state,
    product: entry,
    quantity: entry.quantity + count,
    price_metadata: price_metadata,
    product_metadata: product_metadata
  });
  updateFormattedValue(state, id);
  state.totalPrice += entry.price * count;
  state.cartCount += count;
  updateFormattedTotalPrice(state);
}

function removeEntry(_ref5) {
  var state = _ref5.state,
      id = _ref5.id;
  var cartDetails = state.cartDetails;
  state.totalPrice -= cartDetails[id].value;
  state.cartCount -= cartDetails[id].quantity;
  delete cartDetails[id];
  updateFormattedTotalPrice(state);
}

function updateQuantity(_ref6) {
  var state = _ref6.state,
      id = _ref6.id,
      quantity = _ref6.quantity;
  var entry = state.cartDetails[id];
  updateEntry({
    state: state,
    id: id,
    count: quantity - entry.quantity
  });
}

var initialState = {
  cartMode: 'checkout-session',
  mode: 'payment',
  currency: 'USD',
  language: isClient ? navigator.language : 'en-US',
  lastClicked: '',
  shouldDisplayCart: false,
  cartCount: 0,
  totalPrice: 0,
  formattedTotalPrice: '',
  cartDetails: {},
  stripe: ''
};
var slice = createSlice({
  name: 'cart',
  initialState: initialState,
  reducers: {
    addItem: {
      reducer: function reducer(state, _ref7) {
        var _ref7$payload = _ref7.payload,
            product = _ref7$payload.product,
            options = _ref7$payload.options;
        var count = options.count,
            price_metadata = options.price_metadata,
            product_metadata = options.product_metadata;
        var id = product.id || product.price_id || product.sku_id || product.sku || v4();

        if (id in state.cartDetails) {
          updateEntry({
            state: state,
            id: id,
            count: count,
            price_metadata: price_metadata,
            product_metadata: product_metadata
          });
        } else {
          createEntry({
            state: state,
            id: id,
            product: product,
            count: count,
            price_metadata: price_metadata,
            product_metadata: product_metadata
          });
        }
      },
      prepare: function prepare(product) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          count: 1
        };
        if (!options.price_metadata) options.price_metadata = {};
        if (!options.product_metadata) options.product_metadata = {};
        if (!options.count) options.count = 1;
        return {
          payload: {
            product: product,
            options: options
          }
        };
      }
    },
    incrementItem: {
      reducer: function reducer(state, _ref8) {
        var _ref8$payload = _ref8.payload,
            id = _ref8$payload.id,
            options = _ref8$payload.options;
        updateEntry({
          state: state,
          id: id,
          count: options.count
        });
      },
      prepare: function prepare(id) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          count: 1
        };
        return {
          payload: {
            id: id,
            options: options
          }
        };
      }
    },
    decrementItem: {
      reducer: function reducer(state, _ref9) {
        var _ref9$payload = _ref9.payload,
            id = _ref9$payload.id,
            options = _ref9$payload.options;
        if (state.cartDetails[id].quantity - options.count <= 0) return removeEntry({
          state: state,
          id: id
        });
        updateEntry({
          state: state,
          id: id,
          count: -options.count
        });
      },
      prepare: function prepare(id) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          count: 1
        };
        return {
          payload: {
            id: id,
            options: options
          }
        };
      }
    },
    clearCart: {
      reducer: function reducer(state) {
        state.cartCount = 0;
        state.totalPrice = 0;
        state.cartDetails = {};
        updateFormattedTotalPrice(state);
      }
    },
    setItemQuantity: {
      reducer: function reducer(state, _ref10) {
        var _ref10$payload = _ref10.payload,
            id = _ref10$payload.id,
            quantity = _ref10$payload.quantity;
        if (quantity > 0 && id in state.cartDetails) return updateQuantity(_objectSpread(_objectSpread({}, state), {}, {
          state: state,
          id: id,
          quantity: quantity
        }));else if (quantity === 0) return removeEntry({
          state: state,
          id: id
        });
      },
      prepare: function prepare(id, quantity) {
        return {
          payload: {
            id: id,
            quantity: quantity
          }
        };
      }
    },
    removeItem: {
      reducer: function reducer(state, _ref11) {
        var id = _ref11.payload.id;
        removeEntry({
          state: state,
          id: id
        });
      },
      prepare: function prepare(id) {
        return {
          payload: {
            id: id
          }
        };
      }
    },
    loadCart: {
      reducer: function reducer(state, _ref12) {
        var _ref12$payload = _ref12.payload,
            cartDetails = _ref12$payload.cartDetails,
            shouldMerge = _ref12$payload.shouldMerge;

        if (!shouldMerge) {
          state.cartCount = 0;
          state.totalPrice = 0;
          state.cartDetails = {};
        }

        for (var id in cartDetails) {
          var entry = cartDetails[id];
          createEntry({
            state: state,
            id: entry.id,
            product: entry,
            count: entry.quantity
          });
        }
      },
      prepare: function prepare(cartDetails) {
        var shouldMerge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return {
          payload: {
            cartDetails: cartDetails,
            shouldMerge: shouldMerge
          }
        };
      }
    },
    handleCartHover: function handleCartHover(state) {
      state.shouldDisplayCart = true;
    },
    handleCartClick: function handleCartClick(state) {
      state.shouldDisplayCart = !state.shouldDisplayCart;
    },
    handleCloseCart: function handleCloseCart(state) {
      state.shouldDisplayCart = false;
    },
    storeLastClicked: function storeLastClicked(state, _ref13) {
      var payload = _ref13.payload;
      state.lastClicked = payload;
    },
    changeStripeKey: function changeStripeKey(state, _ref14) {
      var payload = _ref14.payload;
      state.stripe = payload;
    },
    changeLanguage: function changeLanguage(state, _ref15) {
      var payload = _ref15.payload;
      state.language = payload;
    },
    changeCurrency: function changeCurrency(state, _ref16) {
      var payload = _ref16.payload;
      state.currency = payload;
    }
  }
});

slice.actions.redirectToCheckout = function (sessionId) {
  return {
    type: 'cart/redirectToCheckout',
    payload: sessionId
  };
};

slice.actions.checkoutSingleItem = function (productId) {
  return {
    type: 'cart/checkoutSingleItem',
    payload: productId
  };
};

var reducer = slice.reducer,
    actions = slice.actions;
/**
 * Returns the constructor name of any value.
 * @param {any} value
 * @returns string
 */

function typeOf(value) {
  if (value === undefined) return 'undefined';
  if (value === null) return 'null';
  return value.constructor.name;
}

var PropertyValueError = /*#__PURE__*/function (_Error) {
  _inherits(PropertyValueError, _Error);

  var _super = _createSuper(PropertyValueError);

  function PropertyValueError(_ref17) {
    var _this;

    var property = _ref17.property,
        method = _ref17.method,
        expected = _ref17.expected,
        received = _ref17.received;

    _classCallCheck(this, PropertyValueError);

    var plural = Array.isArray(expected);
    var expectedString = plural ? "are ".concat(expected.map(function (v) {
      return JSON.stringify(v);
    }).join(', ')) : "is ".concat(JSON.stringify(expected));
    var methodString = typeof method === 'string' ? " in ".concat(method, "()") : '';
    _this = _super.call(this, "Invalid value ".concat(JSON.stringify(received), " was received for ").concat(property, ". Valid ").concat(plural ? 'values' : 'value', " for ").concat(property).concat(methodString, " ").concat(expectedString, "."));
    _this.name = 'PropertyValueError';
    return _this;
  }

  return PropertyValueError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PropertyTypeError = /*#__PURE__*/function (_TypeError) {
  _inherits(PropertyTypeError, _TypeError);

  var _super2 = _createSuper(PropertyTypeError);

  function PropertyTypeError(_ref18) {
    var _this2;

    var property = _ref18.property,
        expected = _ref18.expected,
        received = _ref18.received;

    _classCallCheck(this, PropertyTypeError);

    var plural = Array.isArray(expected);
    var expectedString = plural ? "are ".concat(expected.map(function (v) {
      return JSON.stringify(v);
    }).join(', ')) : "is ".concat(JSON.stringify(expected));
    _this2 = _super2.call(this, "Invalid value with type ".concat(JSON.stringify(received), " was received for ").concat(property, ". Valid ").concat(plural ? 'types' : 'type', " for ").concat(property, " ").concat(expectedString, "."));
    _this2.name = 'PropertyTypeError';
    return _this2;
  }

  return PropertyTypeError;
}( /*#__PURE__*/_wrapNativeSuper(TypeError));

var PropertyRangeError = /*#__PURE__*/function (_RangeError) {
  _inherits(PropertyRangeError, _RangeError);

  var _super3 = _createSuper(PropertyRangeError);

  function PropertyRangeError(_ref19) {
    var _this3;

    var property = _ref19.property,
        between = _ref19.between,
        below = _ref19.below,
        above = _ref19.above,
        received = _ref19.received;

    _classCallCheck(this, PropertyRangeError);

    var expectedString;
    if (Array.isArray(between)) expectedString = "between ".concat(between[0], " and ").concat(between[1]);else if (['string', 'number'].includes(typeof below)) expectedString = "below ".concat(below);else if (['string', 'number'].includes(typeof above)) expectedString = "above ".concat(above);
    _this3 = _super3.call(this, "Invalid value ".concat(JSON.stringify(received), " was received for ").concat(property, ". Valid range for ").concat(property, " is ").concat(expectedString, "."));
    _this3.name = 'PropertyRangeError';
    return _this3;
  }

  return PropertyRangeError;
}( /*#__PURE__*/_wrapNativeSuper(RangeError));

function _optionalChain(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;

  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;

    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }

    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_value = value).call.apply(_value, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }

  return value;
}

function getCheckoutData(cart) {
  var lineItems = [];

  for (var sku in cart.cartDetails) {
    lineItems.push({
      price: sku,
      quantity: cart.cartDetails[sku].quantity
    });
  }

  var options = {
    mode: cart.mode,
    lineItems: lineItems,
    successUrl: cart.successUrl,
    cancelUrl: cart.cancelUrl,
    billingAddressCollection: cart.billingAddressCollection ? 'required' : 'auto',
    submitType: 'auto'
  };

  if (_optionalChain([cart, 'access', function (_) {
    return _.allowedCountries;
  }, 'optionalAccess', function (_2) {
    return _2.length;
  }])) {
    options.shippingAddressCollection = {
      allowedCountries: cart.allowedCountries
    };
  }

  return options;
}

var handleStripe = function handleStripe(store) {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
        var stripePublicKey, cart, checkout, stripe, checkoutData, _stripe, productId, options;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                stripePublicKey = store.getState().stripe;
                cart = store.getState();
                checkout = ['cart/redirectToCheckout', 'cart/checkoutSingleItem'];

                if (!checkout.includes(action.type)) {
                  _context.next = 10;
                  break;
                }

                if (!(typeof stripePublicKey !== 'string')) {
                  _context.next = 8;
                  break;
                }

                throw new PropertyTypeError({
                  property: 'stripe',
                  expected: 'string',
                  received: typeOf(stripePublicKey)
                });

              case 8:
                if (!(stripePublicKey.length === 0)) {
                  _context.next = 10;
                  break;
                }

                throw new PropertyRangeError({
                  property: 'stripe.length',
                  above: 0,
                  received: stripePublicKey.length
                });

              case 10:
                if (!(action.type === 'cart/redirectToCheckout')) {
                  _context.next = 24;
                  break;
                }

                stripe = initializeStripe(stripePublicKey);

                if (!(cart.cartMode === 'checkout-session')) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return", stripe.redirectToCheckout({
                  sessionId: action.payload.sessionId
                }));

              case 16:
                if (!(cart.cartMode === 'client-only')) {
                  _context.next = 21;
                  break;
                }

                checkoutData = getCheckoutData(cart);
                return _context.abrupt("return", stripe.redirectToCheckout(checkoutData));

              case 21:
                throw new PropertyValueError({
                  property: 'cartMode',
                  method: 'redirectToCheckout',
                  expected: ['client-only', 'checkout-session'],
                  received: cart.cartMode
                });

              case 22:
                _context.next = 33;
                break;

              case 24:
                if (!(action.type === 'cart/checkoutSingleItem')) {
                  _context.next = 33;
                  break;
                }

                _stripe = initializeStripe(stripePublicKey);

                if (!(cart.cartMode === 'client-only')) {
                  _context.next = 32;
                  break;
                }

                productId = action.payload.productId;
                options = {
                  mode: cart.mode,
                  successUrl: cart.successUrl,
                  cancelUrl: cart.cancelUrl,
                  lineItems: [{
                    price: productId,
                    quantity: 1
                  }]
                };
                return _context.abrupt("return", _stripe.redirectToCheckout(options));

              case 32:
                throw new PropertyValueError({
                  property: 'cartMode',
                  method: 'checkoutSingleItem',
                  expected: 'client-only',
                  received: cart.cartMode
                });

              case 33:
                return _context.abrupt("return", next(action));

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref20.apply(this, arguments);
      };
    }();
  };
};

function initializeStripe(publicKey) {
  try {
    // eslint-disable-next-line no-undef
    var stripe = Stripe(publicKey);
    stripe.registerAppInfo({
      name: 'use-shopping-cart',
      version: "3.0.3",
      url: 'https://useshoppingcart.com',
      // eslint-disable-next-line camelcase
      partner_id: 'pp_partner_H8MLmI3e9Oc3IK'
    });
    return stripe;
  } catch (error) {
    console.error('Unable to initialize Stripe.');
    throw error;
  }
}

var handleWarnings = function handleWarnings(store) {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(action) {
        var count, quantity, id;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                count = ['cart/addItem', 'cart/incrementItem', 'cart/decrementItem'];

                if (!(count.includes(action.type) && typeof action.payload.options.count !== 'number')) {
                  _context2.next = 4;
                  break;
                }

                console.warn("Invalid count used with action ".concat(action.type, ": count must be a number. The current type is ").concat(typeOf(action.payload.options.count), "."), action);
                return _context2.abrupt("return");

              case 4:
                quantity = ['cart/setItemQuantity'];

                if (!quantity.includes(action.type)) {
                  _context2.next = 14;
                  break;
                }

                if (!(typeof action.payload.quantity !== 'number')) {
                  _context2.next = 11;
                  break;
                }

                console.warn("Invalid quantity used with action ".concat(action.type, ": quantity must be a number. The current type is ").concat(typeOf(action.payload.quantity), "."), action);
                return _context2.abrupt("return");

              case 11:
                if (!(action.payload.quantity < 0)) {
                  _context2.next = 14;
                  break;
                }

                console.warn("Invalid quantity used with action ".concat(action.type, ": quantity must be greater than zero. The current value is ").concat(JSON.stringify(action.payload.quantity), "."), action);
                return _context2.abrupt("return");

              case 14:
                id = ['cart/incrementItem', 'cart/decrementItem', 'cart/removeItem'];

                if (!(id.includes(action.type) && !(action.payload.id in store.getState().cartDetails))) {
                  _context2.next = 18;
                  break;
                }

                console.warn("Invalid product ID used with action ".concat(action.type, ": the ID must already be in the cart. The current value is ").concat(JSON.stringify(action.payload.id), "."), action);
                return _context2.abrupt("return");

              case 18:
                return _context2.abrupt("return", next(action));

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref21.apply(this, arguments);
      };
    }();
  };
};

function filterCart(_x3, _x4) {
  return _filterCart.apply(this, arguments);
}

function _filterCart() {
  _filterCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cartDetails, filter) {
    var filteredCart, sku, entry;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            filteredCart = {};
            _context6.t0 = _regeneratorRuntime.keys(cartDetails);

          case 2:
            if ((_context6.t1 = _context6.t0()).done) {
              _context6.next = 11;
              break;
            }

            sku = _context6.t1.value;
            entry = cartDetails[sku];
            _context6.next = 7;
            return filter(entry);

          case 7:
            if (!_context6.sent) {
              _context6.next = 9;
              break;
            }

            filteredCart[sku] = entry;

          case 9:
            _context6.next = 2;
            break;

          case 11:
            return _context6.abrupt("return", filteredCart);

          case 12:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _filterCart.apply(this, arguments);
}

function noop() {}

function createNoopStorage() {
  return {
    getItem: noop,
    setItem: noop,
    removeItem: noop
  };
}

function createLocalStorage() {
  return {
    getItem: function getItem(key) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", window.localStorage.getItem(key));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    setItem: function setItem(key, value) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", window.localStorage.setItem(key, value));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    removeItem: function removeItem(key) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", window.localStorage.removeItem(key));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  };
}

function createShoppingCartStore(options) {
  if (!isClient) {
    return configureStore({
      reducer: reducer,
      preloadedState: _objectSpread(_objectSpread({}, initialState), options)
    });
  }

  var storage;
  if (isClient) storage = options.storage || createLocalStorage();else storage = createNoopStorage();
  delete options.storage;
  var persistConfig = {
    key: 'root',
    version: 1,
    storage: storage,
    whitelist: ['cartCount', 'totalPrice', 'formattedTotalPrice', 'cartDetails']
  };
  var persistedReducer = persistReducer(persistConfig, reducer);

  var newInitialState = _objectSpread(_objectSpread({}, initialState), options);

  updateFormattedTotalPrice(newInitialState);
  return configureStore({
    reducer: persistedReducer,
    preloadedState: newInitialState,
    middleware: function middleware(getDefaultMiddleware) {
      return getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
        }
      }).concat(handleStripe, handleWarnings);
    }
  });
}

var _jsxFileName = "/Users/nickdejesus/Code/hooks/use-shopping-cart/use-shopping-cart/react/index.js";
var CartContext = React.createContext(initialState);
var useSelector = createSelectorHook(CartContext);
var useDispatch = createDispatchHook(CartContext);

function CartProvider(_ref22) {
  var _ref22$loading = _ref22.loading,
      loading = _ref22$loading === void 0 ? null : _ref22$loading,
      _children = _ref22.children,
      props = _objectWithoutProperties(_ref22, _excluded);

  var store = React.useMemo(function () {
    return createShoppingCartStore(props);
  }, [props]);
  var persistor = persistStore(store);
  return React.createElement(Provider, {
    context: CartContext,
    store: store,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    }
  }, React.createElement(PersistGate, {
    persistor: persistor,
    children: function children(bootstrapped) {
      if (!bootstrapped) return loading;
      return _children;
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24
    }
  }));
}

function useShoppingCart() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {
    return _objectSpread({}, state);
  };
  var equalityFn = arguments.length > 1 ? arguments[1] : undefined;
  var dispatch = useDispatch();
  var cartState = useSelector(selector, equalityFn);
  var shoppingCart = React.useMemo(function () {
    var cartActions = bindActionCreators(actions, dispatch);
    return _objectSpread(_objectSpread({}, cartState), cartActions);
  }, [cartState, dispatch]);
  React.useDebugValue(shoppingCart);
  return shoppingCart;
}

function DebugCart(props) {
  var _this4 = this;

  var cart = useShoppingCart(function (state) {
    return state;
  });
  var cartPropertyRows = Object.entries(cart).filter(function (_ref23) {
    var _ref24 = _slicedToArray(_ref23, 2),
        value = _ref24[1];

    return typeof value !== 'function';
  }).map(function (_ref25) {
    var _ref26 = _slicedToArray(_ref25, 2),
        key = _ref26[0],
        value = _ref26[1];

    return React.createElement('tr', {
      key: key,
      __self: _this4,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56
      }
    }, React.createElement('td', {
      __self: _this4,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57
      }
    }, key), React.createElement('td', {
      __self: _this4,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58
      }
    }, typeof value === 'object' ? React.createElement('button', {
      onClick: function onClick() {
        return console.log(value);
      },
      __self: _this4,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60
      }
    }, "Log value") : JSON.stringify(value)));
  });
  return React.createElement('table', _objectSpread(_objectSpread({
    style: {
      position: 'fixed',
      top: 50,
      right: 50,
      backgroundColor: '#eee',
      textAlign: 'left',
      maxWidth: 500,
      padding: 20,
      borderSpacing: '25px 5px'
    }
  }, props), {}, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69
    }
  }), React.createElement('thead', {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82
    }
  }, React.createElement('tr', {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83
    }
  }, React.createElement('th', {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84
    }
  }, "Key"), React.createElement('th', {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85
    }
  }, "Value"))), React.createElement('tbody', {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88
    }
  }, cartPropertyRows));
}

export { CartContext, CartProvider, DebugCart, actions, filterCart, formatCurrencyString, useDispatch, useSelector, useShoppingCart };